export const DISPLAY_NAME_EMAIL_ERROR = 'Use a name or stage name instead of an email address.';

const EMAIL_ADDRESS_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function looksLikeEmailAddress(value: string | null | undefined) {
  return Boolean(value && EMAIL_ADDRESS_PATTERN.test(value.trim()));
}

export function getDisplayNameValidationMessage(value: string) {
  if (!value.trim()) return 'Name is required';
  if (looksLikeEmailAddress(value)) return DISPLAY_NAME_EMAIL_ERROR;
  return null;
}
